<template>
  <div class="text-xs-center">
    <template v-if="loading">
      <v-progress-circular class="my-4" indeterminate color="primary"></v-progress-circular>
    </template>
    <div v-else>
      <img
        :src="image"
        :alt="image"
        :title="image"
        style="width:100%;word-wrap: break-word;cursor: pointer; max-width: 500px;"
        v-if="image"
        @click="isShow = true"
      />
      <preview-image @close="isShow = false" v-model="isShow">
        <img :src="image" slot="body" :alt="image" v-if="image" style="width: 100%" />
      </preview-image>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import PreviewImage from '@/components/elements/PreviewImage'
import { mapGetters } from 'vuex'
export default {
  props: ['value', 'orderid'],
  data() {
    return {
      image: this.value,
      isShow: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      products: 'getProducts',
      loadingProduct: 'getLoadingProduct'
    })
  },
  components: {
    PreviewImage
  },
  async mounted() {
    this.loading = true
    var order = await this.getOrderById(this.orderid)
    console.log(order)
    if (order.data && order.data.length > 0) {
      this.image = order.data[0].note
    }
    this.loading = false
  },
  methods: {
    getOrderById(id) {
      return new Promise((resolve, reject) => {
        api.getordersbyid({ id: id, pageid: this.selectedBot.pageid }, function(error, response) {
          if (error) {
            console.error(error)
            reject(error)
            return
          }

          resolve(response)
        })
      })
    }
  },
  watch: {
    value: function(val) {
      console.log(val)
      if (val) {
        this.image = val
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/LoadBase64.vue